// src/components/mediaKit/CreateMediaKitBanner.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Sparkles, ArrowRight } from 'lucide-react';

export default function CreateMediaKitBanner({ kitCount = 0 }) {
    const navigate = useNavigate();
    const hasKits = kitCount > 0;

    return (
        <div
            onClick={() => navigate(hasKits ? '/aip/media-kit' : '/aip/media-kit/new')}
            className="mb-12 cursor-pointer group relative overflow-hidden rounded-2xl p-8 sm:p-10 text-white shadow-2xl"
            style={{ background: 'radial-gradient(circle at 20% 20%, #7c3aed, transparent 55%), radial-gradient(circle at 80% 80%, #06b6d4, transparent 55%), #0b0f19' }}
        >
            <div className="relative z-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
                <div>
                    <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider bg-white/10 px-3 py-1 rounded-full mb-3">
                        <Sparkles size={13} /> New
                    </span>
                    <h2 className="text-2xl sm:text-3xl font-black tracking-tight">
                        {hasKits ? `Your media kits (${kitCount})` : 'Create my media kit'}
                    </h2>
                    <p className="text-sm text-slate-300 mt-2 max-w-xl">
                        {hasKits
                            ? 'View, edit, or create another one-page portfolio to share with brands.'
                            : 'Build a one-page portfolio brands can browse — your stats, your rates, and your best videos, all in one shareable link.'}
                    </p>
                </div>
                <div className="shrink-0 inline-flex items-center gap-2 bg-white text-slate-900 font-bold px-6 py-3 rounded-xl group-hover:gap-3 transition-all">
                    {hasKits ? 'View my kits' : 'Get started'} <ArrowRight size={18} />
                </div>
            </div>
        </div>
    );
}